export default "__VITE_ASSET__e90087bd__"